import React, { useEffect, useState } from "react";
import { UserCircleIcon } from "@heroicons/react/outline";
import { connect } from "react-redux";
import {
  increaseCounter,
  decreaseCounter,
} from "../../redux/counter/counter.actions";
import axiosAPI from "../../utils/axios-api";
const API = process.env.REACT_APP_API;
function SideBar(props) {
  const [pencapaian, setpencapaian] = useState({});
  const [responden, setresponden] = useState([]);

  let menuDummy = [
    {
      title: "Kuesioner",
      value: pencapaian?.kuesioner ?? "",
      icon: UserCircleIcon,
      color: "bg-red-400",
    },
    {
      title: "Partisipasi",
      value: pencapaian?.partisipasi ?? "",
      icon: UserCircleIcon,
      color: "bg-green-400",
    },
    {
      title: "Responden",
      value: pencapaian?.responden ?? "",
      icon: UserCircleIcon,
      color: "bg-purple-400",
    },
    {
      title: "Scoin",
      value: pencapaian?.scoin ?? "",
      icon: UserCircleIcon,
      color: "bg-yellow-400",
    },
    {
      title: "Poin",
      value: pencapaian?.poin ?? "",
      icon: UserCircleIcon,
      color: "bg-blue-400",
    },
  ];

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
    // alert(data.token)
    if(data.token){
      getPencapaian();
      getResponden();
    }
  }, []);

  function getPencapaian(params) {
    axiosAPI.get(API + "user/pencapaian").then((res) => {
      setpencapaian(res.data.data);
    });
  }

  function getResponden(params) {
    axiosAPI.get(API + "responden/top-list?jumlah=5").then(res => {
      setresponden(res.data.data)
    })
  }
  return (
    <div
      className="w-2/12 fixed border-r border-gray-300 bg-white dark:bg-gray-800 text-black dark:text-white dark:border-gray-600 p-6"
      style={{
        minHeight: "100vh",
        maxHeight: "100vh",
        overflowY: "scroll",
        minWidth: "250px",
      }}
    >
      <div>
        <h1 className="text-lg font-bold my-6">Pencapaian</h1>
        <div className="grid grid-flow-col grid-cols-2 gap-2">
          {/* <button
            onClick={() => props.increaseCounter()}
            className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white"
          >
            <p className="text-xs">7 hari terakhir</p>
          </button>
          <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg border border-blue-500 text-blue-500">
            <p className="text-xs">Keseluruhan</p>
          </button> */}
        </div>
        <div className="flex flex-col">
          {menuDummy.map((val, idx) => {
            return (
              <div key={idx} className="flex flex-row w-full items-center my-2">
                <span className={`${val.color} p-1 rounded-full mr-2`}>
                  <val.icon className="h-4 w-4 text-white" />
                </span>
                <div className="flex flex-row flex-1 justify-between">
                  <p className="font-bold">{val.title}</p>

                  <p className="font-bold">{val.value}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <h1 className="text-lg font-bold my-6">Responden</h1>
      <div className="flex flex-col">
        {
        responden.length > 0 ?
        responden.map((val, idx) => {
          return (
            <div key={idx} className="flex flex-row w-full items-center my-2">
              <UserCircleIcon className="h-6 w-6 mr-2" />
              <div className="flex flex-row flex-1 justify-between">
                <p className="text-sm font-bold">{val.nama}</p>

                <span className="border text-xs border-blue-400 rounded p-1 bg-blue-50 dark:bg-blue-900 text-blue-400">
                  {val.poin} Point
                </span>
              </div>
            </div>
          );
        })
        :
        <div className="">Data tdk ditemukan</div>
        }
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    count: state.counter.count,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    increaseCounter: () => dispatch(increaseCounter()),
    decreaseCounter: () => dispatch(decreaseCounter()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
